import React from 'react';
import { Box, Grid, TextField, Accordion, AccordionSummary, Typography, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useCallback, useMemo, useState, useEffect } from 'react';
import axios from "../../../utils/fvAxios";
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F2F4F7",
    color: "#667085",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));


export default function EditVendorpayments({ org, Vendorid }) {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [Pay, setPay] = useState([]);
  const [annual, setAnnual] = useState([]);
  const [openPeriod, setOpenPeriod] = useState([]);
  const [subscription, setsubscription] = useState([]);
  const [preq, setPreq] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [popup, setPopup] = React.useState([]);

  const handleClickOpen = (e) => {
    setOpen(true);
    setPopup(e)
  };
  const handleClose = () => {
    setOpen(false);
  };
  const venid = Vendorid == null ? org : Vendorid

  useEffect(() => {
    if (venid) {
      axios.get("Prequalification/GetPrequalificationPayments?vendorId=" + venid + "&pageNumber=1&pageSize=100"
      ).then((res) => {
        if (res?.data?.responseCode === 100) {
          setPreq(res?.data?.data)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        setIsLoading(false);
      });
    }
  }, [venid]);

  useEffect(() => {
    if (venid) {
      axios.get("Companies/GetQuizPayments?vendorId=" + venid
      ).then((res) => {
        if (res?.data?.responseCode === 100) {
          setPay(res?.data?.data?.moodlePayments?.data)
          setAnnual(res?.data?.data?.annualPayments?.data)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        setIsLoading(false);
      });

      axios.get("Prequalification/GetVendorOpenPeriods?vendorId=" + venid
      ).then((resp) => {
        if (resp?.data?.responseCode === 100) {
          setOpenPeriod(resp?.data?.data)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        setIsLoading(false);
      });

      axios.get("Prequalification/GetMembershipPaymentHistory?vendorId=" + venid + "&pageNumber=1&pageSize=100"
      ).then((resp) => {
        if (resp?.data?.responseCode === 100) {
          setsubscription(resp?.data?.data)
        }
        else {
          setError(resp.data.responseMessage);
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        setIsLoading(false);
      });
      
    }
  }, [org]);
  const groupedData = Pay?.reduce((groups, item) => {
    const key = item?.clientName;
    if (!groups[key]) {
      groups[key] = [];
    }
    groups[key].push(item);
    return groups;
  }, {});
  const groupedData3 = annual?.reduce((groups, item) => {
    const key = item?.clientName;
    if (!groups[key]) {
      groups[key] = [];
    }
    groups[key].push(item);
    return groups;
  }, {});

  function formatDateAndTime(dateTime) {
    const options = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };
    const formattedDate = new Date(dateTime).toLocaleString(undefined, options);

    // Replace the comma after the date with a space
    const formattedDateWithoutComma = formattedDate.replace(/,/, '');

    return formattedDateWithoutComma.toUpperCase();
  }

  const groupedData1 = preq?.reduce((groups, item) => {
    const feeCapPeriod = item.feeCapPeriod;
    if (!groups[feeCapPeriod]) {
      groups[feeCapPeriod] = [];
    }
    groups[feeCapPeriod].push(item);
    return groups;
  }, {})

  return (
    <Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "900px",
            },
          },
        }}
      >
        <DialogContent sx={{ padding: "48px 48px" }} >
          <div style={{ float: "right" }}><span onClick={handleClose} style={{ color: "red", fontWeight: "800", cursor: "pointer" }}><CloseOutlinedIcon /></span></div>
          <DialogTitle
            sx={{
              textAlign: "center",
              fontWeight: 500,
              fontSize: 20,
            }}
          >
            <span style={{ fontSize: "larger" }} >Quiz Payment Details</span>
          </DialogTitle>

          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 600 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <StyledTableCell >Course Name</StyledTableCell>
                  <StyledTableCell>Employee Name</StyledTableCell>
                  <StyledTableCell align="center">Received Date</StyledTableCell>

                  <StyledTableCell align="right">Amount Paid Per Course</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {popup?.map((row) => (
                  <TableRow
                    key={row?.paymentTransactionId}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell component="th" scope="row">
                      {row?.quizName}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row?.employeeName}
                    </TableCell>
                    <TableCell align="right">
                      {/* {formatDateAndTime(row.paymentReceivedDate)} */}
                      {GetfVDateFormate("", row?.paymentReceivedDate)}
                    </TableCell>

                    <TableCell align="center">
                      {row?.actualAmountPaid == (0 || null) ? "" : "$" + row?.actualAmountPaid?.toFixed(2)}
                      {/* {row.actualAmountPaid} */}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>


      <Box
        border={1}
        borderLeft={1}
        borderRight={1}
        borderColor="#e4e7ec"
        className="mt-2"
        sx={{ background: "#fff", marginBottom: "10px" }}>
        <p style={{ fontSize: "18px", color: "#3E4A62", fontWeight: '500', padding: "10px", marginTop: "10px" }}>
          Fee Cap Details
        </p>
        <span style={{ fontSize: "14px", color: "#3E4A62", padding: "10px" }} hidden={openPeriod?.length > 0}>
          No Prequalification periods
        </span>
        <TableContainer component={Paper} hidden={openPeriod?.length === 0}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table" >
            <TableHead>
              <TableRow>
                <StyledTableCell>Period Start</StyledTableCell>
                <StyledTableCell >Period End</StyledTableCell>
                <StyledTableCell align="center">Period Status</StyledTableCell>
                <StyledTableCell align="center">Total Payments Received</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody >
              {openPeriod?.map((row) => (
                <TableRow
                  key={row?.paymentTransactionId}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                //hidden={row?.periodStatus == "1"}
                >
                  <TableCell>
                    {formatDateAndTime(row?.periodStart)}
                  </TableCell>
                  <TableCell>
                    {formatDateAndTime(row?.periodClose)}
                  </TableCell>
                  <TableCell align="center">{row?.periodStatus == "1" ? "Close" : "Open"}</TableCell>
                  <TableCell align="center">${row?.totalPaymentRecieved}</TableCell>
                </TableRow>
              ))
              }
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Box
        border={1}
        borderLeft={1}
        borderRight={1}
        borderColor="#e4e7ec"
        className="mt-2"
        sx={{ background: "#fff", marginBottom: "10px" }}>
        <p style={{ fontSize: "18px", color: "#3E4A62", fontWeight: '500', padding: "10px", marginTop: "10px" }}>
          Prequalification Payments
        </p>
        <hr />
        <span style={{ fontSize: "14px", color: "#3E4A62", padding: "10px" }} hidden={preq?.length > 0}>
          No Prequalification Payments
        </span>
        {Object?.entries(groupedData1)?.map(([key, items]) => (
          <Accordion key={key} hidden={preq?.length === 0}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel-${key}-content`}
              id={`panel-${key}-header`}
            >
              <Typography>{key}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Transaction ID</StyledTableCell>
                      <StyledTableCell align="center">Received Date</StyledTableCell>
                      <StyledTableCell align="center">Template Name</StyledTableCell>
                      <StyledTableCell align="center">Amount</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {items?.map((row) => (
                      <TableRow
                        key={row?.paymentTransactionId}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row">
                          {row?.paymentTransactionId}
                        </TableCell>
                        <TableCell align="center">
                          {GetfVDateFormate("", row?.paymentReceivedDate)}
                        </TableCell>
                        <TableCell align="center">{row?.templateName}</TableCell>
                        <TableCell align="center">
                          ${row?.paymentReceivedAmount}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>

      <Box
        border={1}
        borderLeft={1}
        borderRight={1}
        borderColor="#e4e7ec"
        className="mt-2"
        sx={{ background: "#fff", marginBottom: "10px" }}>
        <p style={{ fontSize: "18px", color: "#3E4A62", fontWeight: '500', padding: "10px", marginTop: "10px" }}>
          Quiz Payments
        </p>
        <hr />
        <span style={{ fontSize: "14px", color: "#3E4A62", padding: "10px" }} hidden={Pay?.length > 0}>
          No Quiz Payments
        </span>
        {Object?.keys(groupedData)?.map((clientName, index) => (
          <Accordion key={index} hidden={Pay?.length == 0}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={`panel${index}-content`} id={`panel${index}-header`}>
              <Typography>{clientName}</Typography>
            </AccordionSummary>
            <AccordionDetails>

              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Transaction ID</StyledTableCell>
                      <StyledTableCell align="right">Received Date</StyledTableCell>
                      <StyledTableCell align="right">	Total Transaction Amount</StyledTableCell>
                      <StyledTableCell align="right">Amount Paid For Client</StyledTableCell>

                      <StyledTableCell align="right">&nbsp;</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object?.values(
                      groupedData[clientName]?.reduce((transactions, payment) => {
                        const transactionId = payment?.paymentTransactionId;
                        if (!transactions[transactionId]) {
                          transactions[transactionId] = [];
                        }
                        transactions[transactionId]?.push(payment);
                        return transactions;
                      }, {})
                    ).map((transactionGroup, innerIndex) => {
                      const totalAmount = transactionGroup.reduce((total, payment) => total + payment?.actualAmountPaid, 0);
                      return (
                        <TableRow key={innerIndex}>
                          <TableCell>{transactionGroup[0]?.paymentTransactionId}</TableCell>
                          <TableCell align="right">
                            {GetfVDateFormate("", transactionGroup[0]?.paymentReceivedDate)}
                            {/* {transactionGroup[0]?.paymentReceivedDate} */}
                          </TableCell>
                          <TableCell align="center">${transactionGroup[0]?.transactionMetaData}</TableCell>

                          <TableCell align="center">{totalAmount?.toFixed(2) == 0 ? " $0.00" : "$" + totalAmount?.toFixed(2)}</TableCell>

                          <TableCell align="right" sx={{ color: "#2A93DB", cursor: "pointer" }}>
                            <div onClick={() => handleClickOpen(transactionGroup)} >   <RemoveRedEyeOutlinedIcon /> View Details</div>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>

      <Box
        border={1}
        borderLeft={1}
        borderRight={1}
        borderColor="#e4e7ec"
        className="mt-2"
        sx={{ background: "#fff", marginBottom: "10px" }}>
        <p style={{ fontSize: "18px", color: "#3E4A62", fontWeight: '500', padding: "10px", marginTop: "10px" }}>
          Annual Training Payments
        </p>
        <hr />
        <span style={{ fontSize: "14px", color: "#3E4A62", padding: "10px" }} hidden={annual?.length > 0}>
          No Annual Training Payments
        </span>
        {Object?.keys(groupedData3)?.map((clientName, index) => (
          <Accordion key={index} hidden={annual?.length == 0}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={`panel${index}-content`} id={`panel${index}-header`}>
              <Typography>{clientName}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Transaction ID</StyledTableCell>
                      <StyledTableCell align="right">Received Date</StyledTableCell>
                      <StyledTableCell align="right">	Total Transaction Amount</StyledTableCell>
                      <StyledTableCell align="right">Amount Paid For Client</StyledTableCell>

                      <StyledTableCell align="right">&nbsp;</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object?.values(
                      groupedData3[clientName]?.reduce((transactions, payment) => {
                        const transactionId = payment?.paymentTransactionId;
                        if (!transactions[transactionId]) {
                          transactions[transactionId] = [];
                        }
                        transactions[transactionId]?.push(payment);
                        return transactions;
                      }, {})
                    ).map((transactionGroup, innerIndex) => {
                      const totalAmount = transactionGroup.reduce((total, payment) => total + payment?.actualAmountPaid, 0);
                      return (
                        <TableRow key={innerIndex}>
                          <TableCell>{transactionGroup[0]?.paymentTransactionId}</TableCell>
                          <TableCell align="right">
                            {/* {transactionGroup[0]?.paymentReceivedDate} */}
                            {GetfVDateFormate("", transactionGroup[0]?.paymentReceivedDate)}
                          </TableCell>
                          <TableCell align="right">${transactionGroup[0]?.transactionMetaData}</TableCell>

                          <TableCell align="right">${totalAmount?.toFixed(2)}</TableCell>

                          <TableCell align="right" sx={{ color: "#2A93DB", cursor: "pointer" }} >
                            <div onClick={() => handleClickOpen(transactionGroup)} >   <RemoveRedEyeOutlinedIcon /> View Details</div>

                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>

      <Box
        border={1}
        borderLeft={1}
        borderRight={1}
        borderColor="#e4e7ec"
        className="mt-2"
        sx={{ background: "#fff", marginBottom: "10px" }}>
        <p style={{ fontSize: "18px", color: "#3E4A62", fontWeight: '500', padding: "10px", marginTop: "10px" }}>
          Subscription Fee Payments
        </p>
        <hr />
        <span style={{ fontSize: "14px", color: "#3E4A62", padding: "10px" }} hidden={subscription?.length > 0}>
          No Subscription Fee Payments
        </span>
        <TableContainer component={Paper} hidden={subscription?.length == 0}>
          <Table sx={{ minWidth: 1000 }} aria-label="simple table">
            <TableHead>
              <TableRow sx={{ backgroundColor: "#F2F4F7", color: "#667085" }}>
                <TableCell style={{ fontSize: "13px", color: "#667085" }}>Transaction ID</TableCell>
                <TableCell style={{ fontSize: "13px", color: "#667085" }}>Received Date</TableCell>
                <TableCell style={{ fontSize: "13px", color: "#667085" }}>Amount </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {subscription?.map((row) => (
                <TableRow
                  key={row?.modifiedOn}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell style={{ fontSize: "13px" }}>{row?.paymentTransactionId}</TableCell>
                  <TableCell style={{ fontSize: "13px" }}>{GetfVDateFormate("", row?.paymentReceivedDate)}</TableCell>
                  <TableCell style={{ fontSize: "13px" }}>${row?.paymentReceivedAmount}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

    </Box>
  )
}
